import { toMessageTimestamp } from '@/utils/messageTime';
/** 统一会话历史：机器人 + 人工的所有消息存在同一条时间线 */
const STORAGE_PREFIX = 'cs_unified_v1';
const MAX_MESSAGES = 400;
function storageKey(visitorId) {
    return `${STORAGE_PREFIX}:${visitorId}`;
}
function sanitize(message) {
    // 本地预览的 blob 图片刷新后失效，不持久化
    const imageUrl = message.imageUrl && !message.imageUrl.startsWith('blob:') ? message.imageUrl : undefined;
    if (message.kind === 'image' && !imageUrl && !message.msgId)
        return null;
    return {
        msgId: message.msgId,
        sessionId: message.sessionId,
        fromImUid: message.fromImUid,
        toImUid: message.toImUid,
        msgType: message.msgType,
        content: message.content ?? '',
        msgTime: message.msgTime,
        fromSelf: message.fromSelf,
        kind: message.kind,
        imageUrl,
        faceIndex: message.faceIndex,
        faceData: message.faceData,
        stickers: message.stickers ? [...message.stickers] : undefined,
        role: message.role,
        title: message.title,
        showOptions: message.showOptions,
    };
}
export function loadUnifiedHistory(visitorId) {
    if (!visitorId)
        return [];
    try {
        const raw = localStorage.getItem(storageKey(visitorId));
        if (!raw)
            return [];
        const parsed = JSON.parse(raw);
        if (!Array.isArray(parsed))
            return [];
        return parsed
            .map((item) => sanitize(item))
            .filter((item) => !!item)
            .sort((a, b) => toMessageTimestamp(a.msgTime) - toMessageTimestamp(b.msgTime));
    }
    catch {
        return [];
    }
}
let saveTimer;
let pending = null;
function flush() {
    if (!pending)
        return;
    const { visitorId, messages } = pending;
    pending = null;
    if (!visitorId)
        return;
    const sanitized = messages
        .map((item) => sanitize(item))
        .filter((item) => !!item)
        .slice(-MAX_MESSAGES);
    try {
        localStorage.setItem(storageKey(visitorId), JSON.stringify(sanitized));
    }
    catch {
        // ignore quota / private mode errors
    }
}
export function saveUnifiedHistory(visitorId, messages, immediate = false) {
    if (!visitorId)
        return;
    pending = { visitorId, messages };
    if (saveTimer)
        clearTimeout(saveTimer);
    if (immediate) {
        flush();
        return;
    }
    saveTimer = setTimeout(() => {
        saveTimer = undefined;
        flush();
    }, 300);
}
export function clearUnifiedHistory(visitorId) {
    if (!visitorId)
        return;
    try {
        localStorage.removeItem(storageKey(visitorId));
    }
    catch {
        // ignore
    }
}
